<template lang="pug">
  div#rnd-view
    mainHeader
    div.box
      div.has-text-centered
        strong.title R&D (Research & Development)
      hr
      TopicCardContainer(:topic_cards="topic_cards")
    Footer
            
</template>


<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";
import TopicCardContainer from "@/components/TopicCardContainer.vue";

export default {
  name: 'rnd',
  components: {
    MainHeader,
    TopicCardContainer,
    Footer
  },
  data: function () {
    return {
      topic_cards: [
        {
          title: "R&D as a Service",
          // image_name: this.get_image_full_path('maintopiccards/SAM_0559.jpg'),
          image_name: '/img/DSC01461copy.jpg',
          // content: "Στη MindCore παρέχουμε υπηρεσίες έρευνας και ανάπτυξης προϊόντων (R&D), στον τομέα του αυτοματισμού και της ηλεκτρονικής για επαγγελματίες ή ιδιώτες. Αναλαμβάνουμε την επίλυση προβλημάτων στους τομείς εξειδίκευσης που δραστηριοποιούμαστε, παρέχοντας ολοκληρωμένες υπηρεσίες έρευνας, μελέτης και σχεδιασμού (software, hardware, mechatronics).",
          content: "",
          has_link_button: true,
          button_text: "Read more...",
          button_link: "/rnd/as-a-service",
        },
        {
          title: "MindCore's R&D",
          // image_name: this.get_image_full_path('maintopiccards/SAM_1005.jpg'),
          image_name: '/img/SAM_0579.jpg',
          content: "",
          has_link_button: true,
          button_text: "Read more...",
          button_link: "/rnd/mindcore",
        },
      ]
    };
  } 
}
</script>

<style scoped>
.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;

}
</style>
